import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";
import { NonAuthRoutes } from "../../app/auth/routes";
import { getConsentValue } from "../../app/hooks/useGoogleAnalytics";

const CONSENT_KEY = "cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(getConsentValue() === null);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    window.dispatchEvent(new Event("cookie_consent_accepted"));
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <p className="cookie-consent__text">
        Šioje svetainėje naudojami slapukai (angl. cookies).{" "}
        <Link to={NonAuthRoutes.privacyPolicy} target="_blank" rel="noopener noreferrer">
          Sužinoti daugiau
        </Link>
        .
      </p>
      <div className="cookie-consent__actions">
        <Button basic primary onClick={decline}>
          Nesutinku
        </Button>
        <Button primary onClick={accept}>
          Sutinku
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
